import React from 'react';
import AndieGenericToolRender from './AndieGenericToolRender';
import { useTranslation } from 'react-i18next';
import { ActionRenderAi } from '@/ai/types/action-render-ai';
import { BarChartRounded } from '@mui/icons-material';

type ActionResponse = Array<Record<string, unknown>>;

export type AndieGetWidgetsAvailableMetricsProps = ActionRenderAi<ActionResponse>;

const AndieGetWidgetsAvailableMetrics = (props: AndieGetWidgetsAvailableMetricsProps) => {
    const { t } = useTranslation();
    return (
        <AndieGenericToolRender<ActionResponse>
            title={() => t('andie.tool.get-widgets-available-metrics.title')}
            icon={<BarChartRounded fontSize="small" />}
            loadingMessages={() => [t('andie.tool.get-widgets-available-metrics.loading')]}
            completeMessage={({ result, args }) =>
                t('andie.tool.get-widgets-available-metrics.complete', {
                    query: args?.search ?? '*',
                    value: result && Array.isArray(result) ? result.length : 0,
                })
            }
            {...props}
        />
    );
};

export default AndieGetWidgetsAvailableMetrics;
